import { ConfigurationColor, } from "@plansoft-configuration-renderer/styles";
export const DebugColor = {
    Default: "secondary",
    Error: "error",
    ConfigurationObject: ConfigurationColor.ConfigurationObject,
    AttributeGroup: ConfigurationColor.ConfigurationGroup,
    Attribute: ConfigurationColor.ConfigurationAttribute,
    Value: ConfigurationColor.ConfigurationValue,
    Groups: ConfigurationColor.ConfigurationGroup,
    Layout: ConfigurationColor.Layout,
    LayoutRow: ConfigurationColor.LayoutRow,
    LayoutCell: ConfigurationColor.LayoutCell,
    Substructure: ConfigurationColor.ConfigurationObject,
};
//# sourceMappingURL=DebugColor.js.map